import React from 'react'
import { Select, type SelectProps } from 'components/Select'
import { type Country } from 'types/graphql-generated'
import { COUNTRY_OPTIONS, EMPTY_COUNTRY_OPTION } from './constants'

export const CountrySearch: React.FC<React.PWC<SelectProps<Country>>> = (
  props
) => (
  <Select
    defaultValue={EMPTY_COUNTRY_OPTION}
    options={COUNTRY_OPTIONS}
    aria-label="country dropdown"
    {...props}
  />
)
